
import { Vue, Component, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';

@Component
export default class EditSupplierModal extends Vue {
  visible = false;

  supplier: any = null;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  form: any = {
    company_name: '',
    contact_name: '',
    contact_phone: '',
  };

  rules: any = {
    company_name: [
      { required: true, message: '请输入公司全称', trigger: 'blur' },
    ],
    contact_phone: [
      {
        pattern: /^1[3-9]\d{9}$/,
        message: '请输入正确的联系电话',
        trigger: 'blur',
      },
    ],
  };

  @Ref('ruleForm')
  private ruleForm!: FormModel;

  get isEdit() {
    return !!(this.supplier && this.supplier.id);
  }

 async open(record?: any) {
    this.supplier = record || null;
    if (record) {
      const res = await this.supplyService.getSupplierDetail({ id: record.id });
      this.form = {
        company_name: res.company_name || '',
        contact_name: res.contact_name || '',
        contact_phone: res.contact_phone || '',
        id: res.id || '',
      };
    } else {
      this.form = {
        company_name: '',
        contact_name: '',
        contact_phone: '',
      };
    }
    this.visible = true;
    this.$nextTick(() => {
      this.ruleForm && this.ruleForm.clearValidate('');
    });
  }

  handleOk() {
    this.ruleForm.validate(async (valid) => {
      if (!valid) {
        return false;
      }
      if (this.isEdit) {
        const params = {
          id: this.supplier.ssCode,
          contact_name: this.form.contact_name,
          contact_phone: this.form.contact_phone,
          company_name: this.form.company_name,
        };
        const res = await this.supplyService.postSupplierEdit(params);
        if (res) {
          this.$message.success('编辑成功');
          this.visible = false;
          this.$emit('refresh');
        }
      } else {
        const params = {
          company_name: this.form.company_name,
          contact_name: this.form.contact_name,
          contact_phone: this.form.contact_phone,
        };
        const res = await this.supplyService.postSupplierEdit(params);
        if (res) {
          this.$message.success('新增成功');
          this.visible = false;
          this.$emit('refresh');
        }
      }
    });
  }

  handleCancel() {
    this.visible = false;
    this.ruleForm.resetFields();
  }
}
